import { useEffect } from 'react';

export function useOnUnmount(fn: () => any, deps: any[] = []): void {
    useEffect(
        () => () => {
            fn();
        },
        deps
    );
}
